/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PatientResponsibilityUpdatedPayloadSideEffectType } from "./PatientResponsibilityUpdatedPayloadSideEffectType";
import type { PatientResponsibilityUpdatedPayloadStatus } from "./PatientResponsibilityUpdatedPayloadStatus";

/**
 * An insurance eligibility check finished, so a cached patient-responsibility read is now stale.
 *
 * Carries no result -- the client refetches ``GET /insurance/patient-responsibility``, which is the
 * authority on what the patient owes.
 */
export interface PatientResponsibilityUpdatedPayload {
  side_effect_type: PatientResponsibilityUpdatedPayloadSideEffectType;
  status: PatientResponsibilityUpdatedPayloadStatus;
}
